import React from "react";
import { useTranslation } from "react-i18next";

import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import projects from "./projectsData";

function ProjectSingleRESUNI() {
  const { t } = useTranslation("projectsTranslation");

  const project = projects.find((p) => p.i18nKey === "resuni");
  const baseKey = "projects.resuni";

  const labels = t(`${baseKey}.page.labels`, { returnObjects: true }) || {};
  const values = t(`${baseKey}.page.values`, { returnObjects: true }) || {};

  const partnersRaw = t(`${baseKey}.page.partners`, { returnObjects: true });
  const partners = Array.isArray(partnersRaw) ? partnersRaw : [];

  const descRaw = t(`${baseKey}.page.description`, { returnObjects: true });
  const description = Array.isArray(descRaw) ? descRaw : [];

  const website = project?.website || "https://resuni.firat.edu.tr/";
  const consortiumText = t(`${baseKey}.sidebar.consortiumValue`, {
    universities: project?.universitiesCount,
    countries: project?.countriesCount,
  });

  return (
    <>
      <Navbar />

      <Bredcom
        title={t("breadcrumb.home")}
        subtitle={t(`${baseKey}.page.title`)}
      />

      <div className="container mt-4 pt-40 project-detail resuni-page">
        <div className="row">
          {/* Main */}
          <div className="col-lg-8 col-md-7">
            <div className="content-container lower-content">
              {/* EU emblem + funding */}
              {project?.logos?.eu && (
                <div className="project-logos mb-4">
                  <img
                    src={project.logos.eu}
                    alt="European Union emblem"
                    className="project-logo-eu"
                  />
                  <span className="project-eu-text">
                    {t(`${baseKey}.page.euFunding`)}
                  </span>
                </div>
              )}

              {/* Cover */}
              {project?.coverImage && (
                <div className="mb-4">
                  <img
                    src={project.coverImage}
                    alt="RES-UNI cover"
                    className="img-fluid"
                    style={{
                      width: "100%",
                      borderRadius: "16px",
                      border: "1px solid #eee",
                    }}
                  />
                </div>
              )}

              {/* Project logo */}
              {project?.logoImage && (
                <div className="project-logos mb-4">
                  <img
                    src={project.logoImage}
                    alt="RES-UNI logo"
                    className="project-logo-main"
                  />
                </div>
              )}

              <h2 className="section-title">{t(`${baseKey}.page.title`)}</h2>

              <div className="textjustify">
                {/* Meta lines */}
                <div className="resuni-meta">
                  <p>
                    <strong>{labels.projectTitle}</strong>{" "}
                    {t(`${baseKey}.page.title`)}
                  </p>

                  <p>
                    <strong>{labels.programme}</strong> {values.programme}
                  </p>

                  <p>
                    <strong>{labels.projectNumber}</strong>{" "}
                    {values.projectNumber}
                  </p>

                  <p>
                    <strong>{labels.projectDuration}</strong>{" "}
                    {values.projectDuration}
                  </p>

                  <p>
                    <strong>{labels.projectCoordinator}</strong>{" "}
                    {values.projectCoordinator}
                  </p>
                </div>
                {/* Partners */}
                <h3 className="mt-4">{labels.partnerInstitutions}</h3>
                <div className="values-section-ka171 resuni-partners">
                  <ul>
                    {partners.map((p, idx) => (
                      <li key={idx}>{p}</li>
                    ))}
                  </ul>
                </div>

                {/* Short description */}
                <h3 className="mt-4">{labels.shortDescription}</h3>
                {description.map((p, idx) => (
                  <p key={idx}>{p}</p>
                ))}

                {/* Website */}
                <p className="mt-3">
                  <strong>{labels.projectWebsite}</strong>{" "}
                  <a href={website} target="_blank" rel="noopener noreferrer">
                    {website}
                  </a>
                </p>

                {/* Disclaimer */}
                <p className="mt-4">
                  <em>{t(`${baseKey}.page.disclaimer`)}</em>
                </p>
              </div>
            </div>
          </div>

          {/* Sidebar */}
          <div className="col-lg-4 col-md-5">
            <div className="info-column">
              <div className="inner-column3">
                <h3>{t(`${baseKey}.sidebar.title`)}</h3>

                <ul className="project-info">
                  <li>
                    <span className="icon">
                      <i className="fas fa-project-diagram" />
                    </span>
                    <div>
                      <h5>{t(`${baseKey}.sidebar.projectTitleLabel`)}</h5>
                      <p>
                        {t(`${baseKey}.page.title`)}
                        <br />
                        <strong>
                          {t(`${baseKey}.sidebar.projectNoLabel`)}
                        </strong>{" "}
                        {project?.projectNoFull || project?.projectNo}
                      </p>
                    </div>
                  </li>

                  <li>
                    <span className="icon">
                      <i className="fas fa-layer-group" />
                    </span>
                    <div>
                      <h5>{t(`${baseKey}.sidebar.programmeLabel`)}</h5>
                      <p>{values.programme}</p>
                    </div>
                  </li>

                  <li>
                    <span className="icon">
                      <i className="fas fa-calendar-alt" />
                    </span>
                    <div>
                      <h5>{t(`${baseKey}.sidebar.durationLabel`)}</h5>
                      <p>
                        {t(`${baseKey}.card.duration`, {
                          months: project?.durationMonths,
                        })}
                      </p>
                    </div>
                  </li>

                  <li>
                    <span className="icon">
                      <i className="fas fa-university" />
                    </span>
                    <div>
                      <h5>{t(`${baseKey}.sidebar.coordinatorLabel`)}</h5>
                      <p>{t(`${baseKey}.card.coordinator`)}</p>
                    </div>
                  </li>

                  <li>
                    <span className="icon">
                      <i className="fas fa-users" />
                    </span>
                    <div>
                      <h5>{t(`${baseKey}.sidebar.consortiumLabel`)}</h5>
                      <p>{consortiumText}</p>
                    </div>
                  </li>

                  <li>
                    <span className="icon">
                      <i className="fas fa-globe" />
                    </span>
                    <div>
                      <h5>{t(`${baseKey}.sidebar.websiteLabel`)}</h5>
                      <p style={{ marginBottom: "10px" }}>
                        <a
                          href={website}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          resuni.firat.edu.tr
                        </a>
                      </p>

                      {/* Socials next to website (same block, as you asked) */}
                      <div style={{ display: "flex", gap: "10px" }}>
                        {project?.social?.instagram && (
                          <a
                            href={project.social.instagram}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Instagram"
                          >
                            <i className="fab fa-instagram" />
                          </a>
                        )}
                        {project?.social?.twitter && (
                          <a
                            href={project.social.twitter}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="X (Twitter)"
                          >
                            <i className="fab fa-twitter" />
                          </a>
                        )}
                        {project?.social?.youtube && (
                          <a
                            href={project.social.youtube}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="YouTube"
                          >
                            <i className="fab fa-youtube" />
                          </a>
                        )}
                      </div>
                    </div>
                  </li>

                  <li>
                    <span className="icon">
                      <i className="fas fa-hashtag" />
                    </span>
                    <div>
                      <h5>{t(`${baseKey}.sidebar.hashtagLabel`)}</h5>
                      <p>{t(`${baseKey}.sidebar.hashtagValue`)}</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default ProjectSingleRESUNI;
